import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '@environments/environment';
import { catchError, map } from 'rxjs';
import { Utils } from '@app/_core/helper/Utils';

import { LoaderService } from './loader.service';
import { WebStorageService } from './webstorage.service';

@Injectable({
  providedIn: 'root',
})
export class DataService {
  constructor(
    private router: Router,
    private http: HttpClient,
    private webStorageService: WebStorageService,
    private loaderService: LoaderService
  ) {}

  /*GetClientUser(id: number): any {
    // const uc = { includeAllLoginParams: false ,user:user,company:company};
    const uc = {
      company: '',
      username: '',
      password: '',
      sessionID: '',
      appClientType: '',
      applicationDesktopID: null,
    };
    uc.username = 'Manoj.D.Gupta@cognizant.com';
    uc.password = 'Help@54321';
    uc.sessionID = '';
    uc.appClientType = 'Browser';
    uc.company = 'QA1';
    // this.loaderService.display(true);
    return this.http.post<any>(`${environment.apiUrl}api/user/login`, uc).pipe(
      // return this.http.post<any>(`${environment.apiUrl}api/services/Manager/GetQueues`, uc).pipe(
      map(res => {
        this.loaderService.display(false);

        res = {
          Data: {
            CustomResponses: {},
            UserID: 5178,
            ProspectID: null,
            Email: 'Akshita.Gupta3@cognizant.com',
            Prefix: null,
            FirstName: 'Akshita',
            MiddleName: null,
            LastName: 'Gupta3',
            Suffix: null,
            FullName: 'Akshita Gupta3',
            Address1: null,
            Address2: null,
            City: null,
            StateID: null,
            PostalCode: null,
            CountryID: null,
            QScore: 0,
            Title: null,
            Company: null,
            JobRoleID: 1,
            JobIndustryID: 1,
            CompanyID: null,
            RegionID: null,
            VanityIDPrefix: 'AkshitaGupta',
            VanityIDSuffix: 24756,
            VanityID: 'AkshitaGupta24756',
            JobLevelID: null,
            CrmUserID: null,
            UserSourceID: null,
            QCertifiedTypeID: null,
            CompanyMatchTypeID: null,
            ShortVanityID: null,
            QCertifiedDate: null,
            DateOfBirth: null,
            FieldResponses: [],
            Country: null,
            Domain: {
              DomainID: 24,
              Name: 'cognizant.com',
              ForceTesting: false,
              Companies: [],
            },
            JobIndustry: {
              JobIndustryID: 1,
              Name: 'Other',
              Type: null,
              ActivityGroupID: null,
            },
            JobRole: { JobRoleID: 1, Name: 'Other', Type: null },
            PhoneNumbers: [
              {
                PhoneNumberID: 6964,
                Number: '(000) 000-0000',
                StrippedNumber: '0000000000',
                Type: 'Business',
              },
            ],
            Role: 'ClientAdmin',
            State: null,
            Grants: [
              'TM',
              'Admin',
              'ManageUsers',
              'SoftphoneOnly',
              'AuditAgents',
              'ManageAgents',
              'Wallboards',
              'ManageIVR',
              'ManageAssignments',
            ],
            JobLevel: null,
            QCertifiedType: null,
            CompanyMatchType: null,
            Experiences: [],
            Facts: [],
            FullCompany: null,
            Priority: null,
            Grouping: null,
            ActivityGroupUserRoleID: null,
            ActivityGroupRole: null,
            CompanyUserRoleID: null,
            CompanyRole: null,
            GroupUserRoleID: null,
            GroupUserRole: null,
            SkillPriority: null,
            SkillPersistent: false,
            Source: null,
            AssignedGroupings: [],
            AuthLevel: 5,
            Rules: [],
            FlatFieldResponses: null,
            GlobalRole: null,
            AvatarLocation: null,
          },
          Status: 1,
          Message: null,
        };

        return res;

        //return res;
      }),
      catchError(Utils.handleHttpError)
      //this.handleError
    );
  }*/
}
